import { FunctionComponent } from 'react'
import './WineOrderDetails.scss'
import { Icon } from '../primitives/Icon/Icon'
import { Text } from '../primitives/Text/Text'
import { WineOrderDetailsProps } from '../OrderStatusCard/OrderStatusCard.types'
import {
  UXComponentType,
  UXComponentVersion
} from '../UXComponentRenderer/uxComponent.types'

import { OrderCardSummary } from '../OrderCardSummary/OrderCardSummary'
import { Button } from '../primitives/Button/Button'

export const WineOrderDetails: FunctionComponent<WineOrderDetailsProps> = ({
  attributes
}) => {
  return (
    <div className="core-ux-wine-order-details">
      <Icon
        attributes={{ asset: attributes.icon, size: 'small' }}
        type={UXComponentType.Icon}
        version={UXComponentVersion.V2}
      />
      <div className="core-ux-wine-order-details__content">
        {attributes.statusText && <Text {...attributes.statusText} />}
        {attributes.detailText && <Text {...attributes.detailText} />}
        <div className="core-ux-wine-order-details__order-summary">
          {attributes.orderSummary && (
            <OrderCardSummary
              type={UXComponentType.OrderCardSummary}
              version={UXComponentVersion.V2}
              attributes={attributes.orderSummary}
            />
          )}
          {attributes.ctaButton && (
            <Button
              type={UXComponentType.Button}
              version={attributes.ctaButton.version}
              attributes={attributes.ctaButton.attributes}
            />
          )}
        </div>
      </div>
    </div>
  )
}
